import { EllipsedText, FlexColumn, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { StyledDivider } from 'baseui/divider';
import { StyledLink } from 'baseui/link';
import { LabelMedium } from 'baseui/typography';
import { useRecoilValue } from 'recoil';
import { ASSET_INFO_ACTION } from '../../../constants/app';
import { ASSET_TYPE_CONTAINER } from '../../../constants/asset';
import { useStyles } from '../../../hooks/useStyles';
import { streamingCurrentStateState } from '../../../storage/streaming';
import { isVehicleKind } from '../../../utils/assets';
import AssetData from '../../shared/AssetData';
import ContainerData from '../../shared/ContainerData';
import VehicleData from '../../shared/VehicleData';
import CurrentStateBasicFooter from '../CurrentStateBasicFooter';
import CurrentStateBasicHeader from '../CurrentStateBasicHeader';

function StreamingCurrentState() {
  const { css, theme, classes } = useStyles();
  const currentState = useRecoilValue(streamingCurrentStateState);
  const { formatDateFromTs } = useMoment();

  if (!currentState) {
    return null;
  }

  const { asset } = currentState;
  const { container, vehicle } = asset;

  return (
    <FlexColumn
      gap={0}
      classNames={css({ overflowY: 'auto' })}
    >
      <FlexColumn>
        <CurrentStateBasicHeader currentState={currentState} />
        <FlexColumn
          gap={theme.sizing.scale200}
          classNames={css({ paddingLeft: theme.sizing.scale500, paddingRight: theme.sizing.scale500 })}
        >
          <LabeledData
            label={'Dirección:'}
            content={
              <StyledLink
                href={`https://maps.google.com/?q=${currentState.position_latitude},${currentState.position_longitude}`}
                target="_blank"
                style={{ color: theme.colors.contentSecondary, ...theme.typography.ParagraphSmall }}
              >
                <EllipsedText
                  maxLines={3}
                  breakAll
                >
                  {currentState.geoReference}
                </EllipsedText>
              </StyledLink>
            }
          />
          <LabeledData
            label={'Horómetro:'}
            content={`${Intl.NumberFormat().format(Math.round(currentState.engine_motorhours))} hrs`}
          />
          <LabeledData
            label={'Velocidad:'}
            content={`${currentState.position_speed} Km/h`}
          />
          <LabeledData
            label={'Alimentación:'}
            content={`${currentState.external_powersource_voltage || 0}`}
          />
          <LabeledData
            label={'Fecha:'}
            content={`${formatDateFromTs(+currentState.timestamp)}`}
          />
        </FlexColumn>
        <FlexColumn gap={0}>
          <StyledDivider style={{ width: '100%', margin: 0 }} />
          <CurrentStateBasicFooter
            currentState={currentState}
            hiddenActions={[ASSET_INFO_ACTION]}
            forStreaming
          />
        </FlexColumn>
      </FlexColumn>
      <FlexColumn gap={theme.sizing.scale800}>
        <AssetData
          asset={asset}
          ident={currentState.ident}
          enabledLabelEdit
        />
        {asset.assetType === ASSET_TYPE_CONTAINER && <ContainerData container={container} />}
        {isVehicleKind(asset.assetType) && (
          <VehicleData
            vehicle={vehicle}
            odometer={currentState.gnss_vehicle_mileage}
            hourometer={currentState.engine_motorhours}
          />
        )}
        <FlexColumn gap={theme.sizing.scale200}>
          <LabelMedium className={classes.dataHeaderClass}>Último reporte</LabelMedium>
          <FlexColumn
            gap={theme.sizing.scale200}
            classNames={classes.dataContentClass}
          >
            <LabeledData
              label="Fecha:"
              content={formatDateFromTs(+currentState.timestamp)}
            />
            <LabeledData
              label="Latitud:"
              content={currentState.position_latitude?.toString()}
            />
            <LabeledData
              label="Longitud:"
              content={currentState.position_longitude?.toString()}
            />
            <LabeledData
              label="Dirección:"
              content={
                <StyledLink
                  href={`https://maps.google.com/?q=${currentState.position_latitude},${currentState.position_longitude}`}
                  target="_blank"
                  style={{
                    color: theme.colors.contentSecondary,
                    ...theme.typography.ParagraphSmall,
                    maxWidth: '200px',
                  }}
                >
                  <EllipsedText maxLines={2}>{currentState.geoReference}</EllipsedText>
                </StyledLink>
              }
            />
          </FlexColumn>
        </FlexColumn>
      </FlexColumn>
    </FlexColumn>
  );
}

export default StreamingCurrentState;
